/** Grid list pages: 3 columns x 2 rows */
export const DEFAULT_PAGE_SIZE = 6

export function unwrapTotal(res) {
  if (!res) return 0
  if (typeof res.total === 'number') return res.total
  if (res.data && typeof res.data.total === 'number') return res.data.total
  return 0
}

export function totalPages(total, pageSize = DEFAULT_PAGE_SIZE) {
  const size = pageSize > 0 ? pageSize : DEFAULT_PAGE_SIZE
  return Math.max(1, Math.ceil((total || 0) / size))
}

export function slicePage(list, pageNum, pageSize = DEFAULT_PAGE_SIZE) {
  const items = list || []
  const size = pageSize > 0 ? pageSize : DEFAULT_PAGE_SIZE
  const page = pageNum > 0 ? pageNum : 1
  const start = (page - 1) * size
  return items.slice(start, start + size)
}

/** Page number buttons (max 7), matching official site style */
export function buildPageNumbers(current, pages, max = 7) {
  const total = pages > 0 ? pages : 1
  if (total <= max) {
    return Array.from({ length: total }, (_, i) => i + 1)
  }
  let start = Math.max(1, current - Math.floor(max / 2))
  let end = start + max - 1
  if (end > total) {
    end = total
    start = end - max + 1
  }
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

export function scrollToListTop(el) {
  if (!el || typeof window === 'undefined') return
  const top = el.getBoundingClientRect().top + window.pageYOffset - 120
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' })
}
